const reports = {
  main: {
    btn: 'Offen'
  },
  filterForm: {
    filter: 'Filter',
    export: 'Exportieren',
    validation: {
      reportTypeRequired: 'Berichtstyp ist erforderlich',
      startDateRequired: 'Startdatum ist erforderlich',
      endDateRequired: 'Enddatum ist erforderlich',
    },
    form: {
      reportType: {
        label: 'Berichtstyp',
        reportTypeOptions: {
          selectReport: 'Bericht auswählen',
          shuttlePassangers: 'Shuttle-Fahrgäste',
          dailySummary: 'Tageszusammenfassung',
          delaysReport: 'Verspätungsbericht',
          shuttleReport: 'Shuttle-Bericht',
          vehicleOccupancy: 'Fahrzeugbelegung',
          commuterSatisfaction: 'Pendlerzufriedenheit',
          passengerCostPareto: 'Fahrgastkosten - PARETO',
          carbonEfficiency: 'Kohlenstoffeffizienz',
          totalTripsPassengers: ' Total Trips/Passengers',
        },
      },
      selectShuttle: 'Shuttle auswählen',
      dateStart: 'Startdatum',
      dateEnd: 'Enddatum',
    },
  },
};

export default reports;
